let _ = t => t,
  _t,
  _t2,
  _t3,
  _BannerLink;
import * as React from 'react';
import styled from 'styled-components';
import { AI2Logo } from '../logos/AI2Logo';
import { Content } from '../Content';
import { jsx as _jsx } from "react/jsx-runtime";
export const BannerLink = styled.a(_t || (_t = _`
  display: inline-block;
  padding: 5px 0 2px 0;
`));
const BannerContent = styled(Content)(_t2 || (_t2 = _`
  padding-top: 0;
  padding-bottom: 0;
`));
const DarkBanner = styled.div(_t3 || (_t3 = _`
  background: ${0};
  padding: ${0} 0;
  line-height: 1;
`), ({
  theme
}) => theme.paletteExtended.background.dark, ({
  theme
}) => theme.spacing(0.5));
export const AI2Banner = /*#__PURE__*/React.forwardRef(({
  children
}) => /*#__PURE__*/_jsx(DarkBanner, {
  children: /*#__PURE__*/_jsx(BannerContent, {
    children: children || _BannerLink || (_BannerLink = /*#__PURE__*/_jsx(BannerLink, {
      href: "https://allenai.org",
      children: /*#__PURE__*/_jsx(AI2Logo, {
        color: "white",
        size: "sm"
      })
    }))
  })
}));